/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/11/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const AreaService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllAreas: builder.query({
            query: () => "/areas",
            providesTags: ['area']
        }),

        getAreaByStateId: builder.query({
            query: (id) => `/areas/by-state/${id}`
        }),

        getAreaById: builder.query({
            query: (id) => `/areas/${id}`,
            providesTags: ['area']
        }),

        createArea: builder.mutation({
            query: (areaDetails) => ({
                url: '/areas',
                method: 'POST',
                body: areaDetails
            }),
            invalidatesTags: ['area']
        }),

        updateArea: builder.mutation({
            query: (areaDetails) => ({
                url: `/areas/${areaDetails.areaId}`,
                method: 'PUT',
                body: areaDetails
            }),
            invalidatesTags: ['area']
        }),

        deleteArea: builder.mutation({
            query: (areaId) => ({
                url: `/areas/${areaId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['area']
        }),

    })
});

export const {
    useGetAllAreasQuery,
    useGetAreaByStateIdQuery,
    useGetAreaByIdQuery,
    useCreateAreaMutation,
    useUpdateAreaMutation,
    useDeleteAreaMutation

} = AreaService;